export default "__VITE_ASSET__Csqe1UV___"